<template>
  <v-dialog v-model="dialog" persistent max-width="450">
    <v-card>
      <v-card-title class="text-h6 text-center">
        Sesión por finalizar
      </v-card-title>
      <v-card-text
        >¿Desea mantener su sesión activa por mas tiempo?</v-card-text
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          text
          @click="
            dialog = false;
            logout();
          "
        >
          Cerrar sesión
        </v-btn>
        <v-btn
          color="primary"
          text
          @click="
            dialog = false;
            resetTimer();
          "
        >
          Mantener
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "AutoLogout",
  data() {
    return {
      dialog: false,
      events: ["click", "mousemove", "mousedown", "scroll", "keypress", "load"],
      warningTimer: null,
      logoutTimer: null,
    };
  },
  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.setTimers();
  },
  beforeDestroy() {
    this.events.forEach(function (event) {
      window.removeEventListener(event, this.resetTimer);
    }, this);
    this.resetTimer2();
  },
  methods: {
    ...mapActions(["logout"]),
    setTimers() {
      this.warningTimer = setTimeout(this.warningMessage, 40 * 60 * 1000);
      if (!this.dialog) {
        this.logoutTimer = setTimeout(this.logout, 50 * 60 * 1000);
      }
    },
    resetTimer() {
      clearTimeout(this.warningTimer);
      if (!this.dialog) {
        clearTimeout(this.logoutTimer);
      }
      this.setTimers();
    },
    resetTimer2() {
      clearTimeout(this.warningTimer);
      clearTimeout(this.logoutTimer);
    },
    warningMessage() {
      this.dialog = true;
    },
  },
};
</script>
